/*
  Окно перед закрытием ссылки, напечатанной в уведомлении (23.10.2026).

  Ссылки всех собранных уведомлений остаются рабочими 45 дней (решение
  владельца 21.10.2026): письмо могло уже уйти почтой. Кнопка «Закрыть» у
  такой ссылки оставлена - это единственный способ отозвать ключ от
  персональных данных, если письмо попало не тому человеку. Но закрытие ломает
  ссылку в бумаге на руках у должника, и об этом сказано ДО нажатия, как при
  замене обычной ссылки (решение владельца 09.09.2026). Ссылку оператора или
  сообщения кабинет закрывает сразу: её можно выдать заново.

  Отдельным файлом, а не в `DebtorLink.jsx`: блок выдачи уже у нормы размера.
*/

import { Confirm } from './Common.jsx'

export default function DebtorLinkCloseConfirm({ busy, error, onConfirm, onCancel }) {
  return (
    <Confirm
      title="Закрыть ссылку из уведомления?"
      action="Закрыть ссылку"
      busy={busy}
      error={error}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      Эта ссылка напечатана в уведомлении, и письмо с ней могло уже уйти должнику почтой. После
      закрытия она перестанет открывать страницу: человек с письмом в руках увидит «Ссылка больше не
      действует», а вписать новую в отправленное письмо нельзя. Закрывайте, только если письмо попало
      не тому человеку или ссылка оказалась у постороннего.
    </Confirm>
  )
}
